export default "__VITE_ASSET__6651d96c__"